"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var createManagedClientsWithState_1 = require("./createManagedClientsWithState");
/**
 * Normalize the region name.
 *
 * Currently this only does anything for R1, because  we use "r1" there instead of the region name.
 *
 * @param regionName The regionName to normalize
 */
function normalizeRegionName(regionName) {
    if (regionName === "us-seattle-1") {
        return "r1";
    }
    return regionName;
}
/**
 * Create managed clients, that depend on a region.
 * Instead of the initializer returning a factory, it must return an object with initial region, and
 * a function that returns a factory when given a region.
 *
 * Clients are cached when the state changes.  This function returns an array containing (in the following order):
 *  [0] - The map of clients
 *  [1] - The initialize function (that takes the same arguments as the initializer function passed as a param)
 *  [2] - A setter function that sets the current region for the managed clients
 *  [3] - A function that allows using clients from a specific region, without having to set the current region.
 *
 * @param clientConfig The client configs to manage
 * @param initializer
 *    The initializer used to initialize the managed clients.  Must return an object containing the initial region, as
 *    well as a function that returns a client factory given a region
 */
function createRegionalManagedClients(configMap, initializer) {
    var _a = __read(createManagedClientsWithState_1.default(configMap, function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _a = initializer.apply(void 0, __spread(args)), initialState = _a.initialRegion, createClients = _a.createClients;
        return {
            initialState: initialState,
            createClients: function (region) {
                return createClients(normalizeRegionName(region));
            },
        };
    }), 4), clientMap = _a[0], initialize = _a[1], setRegion = _a[2], withRegion = _a[3];
    return [
        clientMap,
        initialize,
        setRegion,
        withRegion,
    ];
}
exports.default = createRegionalManagedClients;
//# sourceMappingURL=createRegionalManagedClients.js.map